var WDN = WDN || {};

if (typeof WDN.HeroMoving === "undefined") {
  document.body.classList.add("hero-movement-transition");
  var particlesContainer = document.querySelector("[data-hero-movement]");
  var imageParticles = particlesContainer.querySelectorAll("[data-particle-item]");
  var particlesContainerCenter = { x: particlesContainer.offsetWidth / 2, y: particlesContainer.offsetHeight / 2 };

  particlesContainer.addEventListener("mousemove", function (e) {
    var offset = 18;

    var posX = ((e.offsetX - particlesContainerCenter.x) * -1) / (offset * 2);
    var posY = ((e.offsetY - particlesContainerCenter.y) * -1) / offset;

    imageParticles.forEach(function (particle) {
      let magnitude = particle.dataset.particleItem * 0.15;
      let finalXPos = posX.toFixed(2) * magnitude;
      let finalYPos = posY.toFixed(2) * magnitude;

      particle.style = "transform:translate(" + finalXPos + "px ," + finalYPos + "px)";
    });
  });
  if (window.innerWidth < 880) {
    if (window.scrollY > particlesContainer.offsetTop / 2 + particlesContainer.offsetHeight / 2 + 150) {
      document.body.classList.add("scrolled-past");
    } else {
      document.body.classList.remove("scrolled-past");
    }
  } else {
    if (window.scrollY > particlesContainer.offsetTop / 2 + particlesContainer.offsetHeight / 2 - 100) {
      document.body.classList.add("scrolled-past");
    } else {
      document.body.classList.remove("scrolled-past");
    }
  }
  window.addEventListener("scroll", function () {
    if (window.innerWidth < 880) {
      if (window.scrollY > particlesContainer.offsetTop / 2 + particlesContainer.offsetHeight / 2 + 150) {
        document.body.classList.add("scrolled-past");
      } else {
        document.body.classList.remove("scrolled-past");
      }
    } else {
      if (window.scrollY > particlesContainer.offsetTop / 2 + particlesContainer.offsetHeight / 2 - 100) {
        document.body.classList.add("scrolled-past");
      } else {
        document.body.classList.remove("scrolled-past");
      }
    }
  });
  /*
        END
        SCRIPT
    */
}
